module.exports = __webpack_public_path__ + "static/media/my_account_icon.be688edc.svg";